/* esm.sh - date-fns@4.1.0/locale/en-US/_lib/formatRelative */
var t={lastWeek:"'last' eeee 'at' p",yesterday:"'yesterday at' p",today:"'today at' p",tomorrow:"'tomorrow at' p",nextWeek:"eeee 'at' p",other:"P"},s=(e,a,o,r)=>t[e];export{s as formatRelative};
//# sourceMappingURL=formatRelative.mjs.map